import React, { Component } from "react";
import { Notification } from "../data/notifications/Notification";
import { withLocale, WithLocaleProps } from "../providers/LocaleProvider";
import { Snackbar } from "./Snackbar";

interface NotificationPopupProps extends WithLocaleProps {}

class NotificationPopupBase extends Component<NotificationPopupProps, any> {
  constructor(props: NotificationPopupProps) {
    super(props);

    this.state = {
      open: false,
      notif: null
    };
  }

  onClose(e: any) {
    this.close();
  }

  open(mode: any, open: any) {
    this.setState({ open: open === true || open === undefined, mode });
  }

  close() {
    this.setState({ open: false });
  }

  onNotificationReceived(notif: any, _numUnread?: number) {
    if (notif.isNew) {
      this.setState({
        open: true,
        notif: notif
      });
    }
  }

  render() {
    const { open, notif } = this.state;
    const { translate } = this.props;

    let message = "";
    if (notif) {
      const primaryText = Notification.resolveText(notif.primaryText, translate);
      const secondaryText = Notification.resolveText(notif.secondaryText, translate);
      message = translate("notifications.prefix") + ": " + primaryText + ": " + secondaryText;
    }

    return (
      <Snackbar
        open={open}
        duration={6000}
        onClose={this.onClose.bind(this)}
        message={message}
      ></Snackbar>
    );
  }
}

export const NotificationPopup = withLocale(NotificationPopupBase);
